/**
 * @file messages.ts
 *
 * UI message descriptors with explicit ids. Explicit ids (rather than the
 * babel-plugin-formatjs auto-id) keep extraction working under CRA without
 * ejecting. `pnpm --filter client i18n:extract` pulls these into the source
 * catalog for Phrase.
 */

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  loading: {
    id: 'app.loading',
    defaultMessage: 'Loading…',
  },
  title: {
    id: 'app.title',
    defaultMessage: 'WSB Commerce Platform',
  },
  tagline: {
    id: 'app.tagline',
    defaultMessage: 'client app — it works.',
  },
  apiLabel: {
    id: 'app.apiLabel',
    defaultMessage: 'commerce-engine API: {url}',
  },
  adminLanguage: {
    id: 'app.adminLanguage',
    defaultMessage: 'Admin language',
  },
  shopfrontLanguage: {
    id: 'app.shopfrontLanguage',
    defaultMessage: 'Shopfront language',
  },
  save: {
    id: 'app.save',
    defaultMessage: 'Save',
  },
  shopfrontError: {
    id: 'app.shopfrontError',
    defaultMessage: 'Could not update the shopfront language. Please try again.',
  },
  shopPreparing: {
    id: 'app.shopPreparing',
    defaultMessage: 'Preparing your shop…',
  },
  planNotEligibleTitle: {
    id: 'app.planNotEligibleTitle',
    defaultMessage: "Commerce isn't available on your plan",
  },
  planNotEligibleBody: {
    id: 'app.planNotEligibleBody',
    defaultMessage:
      'A shop is available on the Commerce plan, or during your trial. Upgrade your plan to start selling.',
  },
  shopErrorTitle: {
    id: 'app.shopErrorTitle',
    defaultMessage: "We couldn't open your shop",
  },
  shopErrorBody: {
    id: 'app.shopErrorBody',
    defaultMessage:
      'Something went wrong while preparing your shop. Please try again.',
  },
  retry: {
    id: 'app.retry',
    defaultMessage: 'Try again',
  },
});
